
import { Link } from 'react-router-dom';

export default function Emergency() {
  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <header className="bg-white shadow-sm border-b">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <div className="flex items-center">
              <Link to="/" className="flex items-center">
                <div className="w-10 h-10 mr-3 relative">
                  <div className="absolute inset-0 bg-gradient-to-br from-teal-500 to-emerald-500 rounded-lg transform rotate-12 shadow-lg"></div>
                  <div className="absolute inset-0 bg-gradient-to-br from-teal-400 to-emerald-400 rounded-lg flex items-center justify-center">
                    <i className="ri-heart-pulse-fill text-white text-lg"></i>
                  </div>
                </div>
                <div className="text-xl font-bold text-teal-600" style={{ fontFamily: '"Pacifico", serif' }}>
                  みんなの薬局～Pharmacare～
                </div>
              </Link>
            </div>
            <nav className="hidden md:flex space-x-8">
              <Link to="/services" className="text-gray-700 hover:text-teal-600 font-medium whitespace-nowrap cursor-pointer">サービス</Link>
              <Link to="/health-support" className="text-gray-700 hover:text-teal-600 font-medium whitespace-nowrap cursor-pointer">健康サポート</Link>
              <Link to="/pharmacist-resources" className="text-gray-700 hover:text-teal-600 font-medium whitespace-nowrap cursor-pointer">薬剤師向け</Link>
              <Link to="/information" className="text-gray-700 hover:text-teal-600 font-medium whitespace-nowrap cursor-pointer">情報提供</Link>
            </nav>
            <button className="md:hidden p-2">
              <i className="ri-menu-line text-xl"></i>
            </button>
          </div>
        </div>
      </header>

      {/* Hero Section */}
      <section className="py-16 bg-gradient-to-br from-red-50 to-orange-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <div className="w-16 h-16 bg-red-100 text-red-600 rounded-full flex items-center justify-center mx-auto mb-6">
              <i className="ri-emergency-line text-2xl"></i>
            </div>
            <h1 className="text-4xl font-bold text-gray-900 mb-4">緊急時対応</h1>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              災害時や緊急時における薬剤師の役割と対応方法について詳しく解説します
            </p>
          </div>
          <div className="flex justify-center">
            <img 
              src="https://public.readdy.ai/ai/img_res/30a83a99cbdc649120a89d1abbcf140d.jpg"
              alt="緊急時対応"
              className="w-full max-w-4xl h-80 object-cover object-top rounded-xl shadow-lg"
            />
          </div>
        </div>
      </section>

      {/* Emergency Contact Section */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl font-bold text-center text-gray-900 mb-12">緊急連絡先</h2>
          <div className="grid md:grid-cols-3 gap-8 mb-16">
            <div className="bg-red-50 rounded-xl p-6 text-center border-2 border-red-200">
              <div className="w-16 h-16 bg-red-100 text-red-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-phone-line text-2xl"></i>
              </div>
              <h3 className="text-xl font-bold text-red-800 mb-2">救急車</h3>
              <p className="text-3xl font-bold text-red-600 mb-2">119</p>
              <p className="text-gray-600 text-sm">生命に関わる緊急事態</p>
            </div>
            <div className="bg-blue-50 rounded-xl p-6 text-center border-2 border-blue-200">
              <div className="w-16 h-16 bg-blue-100 text-blue-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-shield-line text-2xl"></i>
              </div>
              <h3 className="text-xl font-bold text-blue-800 mb-2">警察</h3>
              <p className="text-3xl font-bold text-blue-600 mb-2">110</p>
              <p className="text-gray-600 text-sm">事件・事故・災害</p>
            </div>
            <div className="bg-green-50 rounded-xl p-6 text-center border-2 border-green-200">
              <div className="w-16 h-16 bg-green-100 text-green-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-information-line text-2xl"></i>
              </div>
              <h3 className="text-xl font-bold text-green-800 mb-2">中毒情報センター</h3>
              <p className="text-lg font-bold text-green-600 mb-2">072-727-2499</p>
              <p className="text-gray-600 text-sm">薬物中毒・誤飲時</p>
            </div>
          </div>
        </div>
      </section>

      {/* Disaster Response Section */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl font-bold text-center text-gray-900 mb-12">災害時の薬剤師活動</h2>
          <div className="grid lg:grid-cols-2 gap-12 items-center mb-16">
            <div>
              <h3 className="text-2xl font-bold text-gray-900 mb-6">災害時における薬剤師の役割</h3>
              <div className="space-y-4">
                <div className="flex items-start">
                  <div className="w-8 h-8 bg-teal-100 text-teal-600 rounded-full flex items-center justify-center mr-4 mt-1">
                    <i className="ri-medicine-bottle-line text-sm"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-1">医薬品の供給・管理</h4>
                    <p className="text-gray-600 text-sm">避難所や医療機関への医薬品供給、在庫管理、品質保持</p>
                  </div>
                </div>
                <div className="flex items-start">
                  <div className="w-8 h-8 bg-teal-100 text-teal-600 rounded-full flex items-center justify-center mr-4 mt-1">
                    <i className="ri-user-heart-line text-sm"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-1">服薬指導・健康相談</h4>
                    <p className="text-gray-600 text-sm">避難者への服薬指導、健康状態の確認、メンタルケア</p>
                  </div>
                </div>
                <div className="flex items-start">
                  <div className="w-8 h-8 bg-teal-100 text-teal-600 rounded-full flex items-center justify-center mr-4 mt-1">
                    <i className="ri-team-line text-sm"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-1">多職種連携</h4>
                    <p className="text-gray-600 text-sm">医師、看護師、行政との連携による総合的な医療支援</p>
                  </div>
                </div>
                <div className="flex items-start">
                  <div className="w-8 h-8 bg-teal-100 text-teal-600 rounded-full flex items-center justify-center mr-4 mt-1">
                    <i className="ri-shield-check-line text-sm"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-1">感染症対策</h4>
                    <p className="text-gray-600 text-sm">避難所での感染症予防、衛生管理指導</p>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <img 
                src="https://readdy.ai/api/search-image?query=Pharmacist%20providing%20medical%20assistance%20in%20disaster%20relief%20center%2C%20professional%20healthcare%20worker%20helping%20evacuees%2C%20organized%20emergency%20medical%20supplies%2C%20clean%20disaster%20response%20facility%2C%20compassionate%20care%20scene&width=500&height=400&seq=disaster-pharmacist-role&orientation=landscape"
                alt="災害時の薬剤師活動"
                className="w-full h-80 object-cover object-top rounded-xl shadow-lg"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Mobile Pharmacy Section */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl font-bold text-center text-gray-900 mb-12">モバイルファーマシー</h2>
          <div className="grid lg:grid-cols-2 gap-12 items-center mb-16">
            <div>
              <img 
                src="https://readdy.ai/api/search-image?query=Mobile%20pharmacy%20vehicle%20with%20medical%20equipment%2C%20modern%20pharmaceutical%20truck%20for%20disaster%20relief%2C%20professional%20mobile%20medical%20unit%2C%20organized%20medicine%20storage%2C%20emergency%20healthcare%20vehicle&width=500&height=400&seq=mobile-pharmacy-vehicle&orientation=landscape"
                alt="モバイルファーマシー"
                className="w-full h-80 object-cover object-top rounded-xl shadow-lg"
              />
            </div>
            <div>
              <h3 className="text-2xl font-bold text-gray-900 mb-6">モバイルファーマシーの特徴</h3>
              <div className="space-y-6">
                <div className="bg-blue-50 rounded-lg p-4">
                  <h4 className="font-semibold text-blue-800 mb-2">🚛 移動式薬局機能</h4>
                  <p className="text-gray-600 text-sm">災害現場や避難所に直接出向き、薬局機能を提供</p>
                </div>
                <div className="bg-green-50 rounded-lg p-4">
                  <h4 className="font-semibold text-green-800 mb-2">💊 医薬品の調剤・供給</h4>
                  <p className="text-gray-600 text-sm">処方箋調剤、OTC医薬品の供給、緊急時医薬品の配布</p>
                </div>
                <div className="bg-purple-50 rounded-lg p-4">
                  <h4 className="font-semibold text-purple-800 mb-2">📋 服薬管理支援</h4>
                  <p className="text-gray-600 text-sm">お薬手帳の確認、服薬指導、薬歴管理</p>
                </div>
                <div className="bg-orange-50 rounded-lg p-4">
                  <h4 className="font-semibold text-orange-800 mb-2">🏥 医療チーム連携</h4>
                  <p className="text-gray-600 text-sm">DMAT、医療救護班との連携による総合医療支援</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* DMAT Collaboration Section */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl font-bold text-center text-gray-900 mb-12">DMAT連携</h2>
          <div className="bg-white rounded-xl shadow-lg p-8 mb-8">
            <div className="text-center mb-8">
              <h3 className="text-2xl font-bold text-gray-900 mb-4">DMAT（災害派遣医療チーム）とは</h3>
              <p className="text-gray-600 max-w-3xl mx-auto">
                Disaster Medical Assistance Teamの略称で、災害急性期（48時間以内）に活動できる機動性を持った、
                専門的な訓練を受けた医療チームです。
              </p>
            </div>
            
            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
              <div className="text-center">
                <div className="w-16 h-16 bg-red-100 text-red-600 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-user-line text-2xl"></i>
                </div>
                <h4 className="font-semibold text-gray-900 mb-2">医師</h4>
                <p className="text-gray-600 text-sm">救急医療の専門知識を持つ医師</p>
              </div>
              <div className="text-center">
                <div className="w-16 h-16 bg-blue-100 text-blue-600 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-nurse-line text-2xl"></i>
                </div>
                <h4 className="font-semibold text-gray-900 mb-2">看護師</h4>
                <p className="text-gray-600 text-sm">災害看護の専門技術を持つ看護師</p>
              </div>
              <div className="text-center">
                <div className="w-16 h-16 bg-green-100 text-green-600 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-medicine-bottle-line text-2xl"></i>
                </div>
                <h4 className="font-semibold text-gray-900 mb-2">薬剤師</h4>
                <p className="text-gray-600 text-sm">災害時医薬品管理の専門家</p>
              </div>
              <div className="text-center">
                <div className="w-16 h-16 bg-purple-100 text-purple-600 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-tools-line text-2xl"></i>
                </div>
                <h4 className="font-semibold text-gray-900 mb-2">業務調整員</h4>
                <p className="text-gray-600 text-sm">ロジスティクス・連絡調整担当</p>
              </div>
            </div>
          </div>

          <div className="grid lg:grid-cols-2 gap-8">
            <div className="bg-white rounded-xl shadow-lg p-6">
              <h3 className="text-xl font-bold text-gray-900 mb-4">薬剤師の役割</h3>
              <ul className="space-y-3">
                <li className="flex items-start">
                  <div className="w-2 h-2 bg-teal-500 rounded-full mt-2 mr-3 flex-shrink-0"></div>
                  <span className="text-gray-700">医薬品の適正使用・管理指導</span>
                </li>
                <li className="flex items-start">
                  <div className="w-2 h-2 bg-teal-500 rounded-full mt-2 mr-3 flex-shrink-0"></div>
                  <span className="text-gray-700">医薬品情報の収集・提供</span>
                </li>
                <li className="flex items-start">
                  <div className="w-2 h-2 bg-teal-500 rounded-full mt-2 mr-3 flex-shrink-0"></div>
                  <span className="text-gray-700">薬物療法の安全性確保</span>
                </li>
                <li className="flex items-start">
                  <div className="w-2 h-2 bg-teal-500 rounded-full mt-2 mr-3 flex-shrink-0"></div>
                  <span className="text-gray-700">医薬品の品質管理・保管</span>
                </li>
                <li className="flex items-start">
                  <div className="w-2 h-2 bg-teal-500 rounded-full mt-2 mr-3 flex-shrink-0"></div>
                  <span className="text-gray-700">チーム医療における薬学的支援</span>
                </li>
              </ul>
            </div>
            <div className="bg-white rounded-xl shadow-lg p-6">
              <h3 className="text-xl font-bold text-gray-900 mb-4">活動内容</h3>
              <ul className="space-y-3">
                <li className="flex items-start">
                  <div className="w-2 h-2 bg-orange-500 rounded-full mt-2 mr-3 flex-shrink-0"></div>
                  <span className="text-gray-700">災害現場での医療活動</span>
                </li>
                <li className="flex items-start">
                  <div className="w-2 h-2 bg-orange-500 rounded-full mt-2 mr-3 flex-shrink-0"></div>
                  <span className="text-gray-700">病院支援（域内搬送）</span>
                </li>
                <li className="flex items-start">
                  <div className="w-2 h-2 bg-orange-500 rounded-full mt-2 mr-3 flex-shrink-0"></div>
                  <span className="text-gray-700">広域医療搬送</span>
                </li>
                <li className="flex items-start">
                  <div className="w-2 h-2 bg-orange-500 rounded-full mt-2 mr-3 flex-shrink-0"></div>
                  <span className="text-gray-700">避難所・救護所での医療支援</span>
                </li>
                <li className="flex items-start">
                  <div className="w-2 h-2 bg-orange-500 rounded-full mt-2 mr-3 flex-shrink-0"></div>
                  <span className="text-gray-700">医療機関の機能回復支援</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Emergency Preparedness Section */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl font-bold text-center text-gray-900 mb-12">緊急時の備え</h2>
          <div className="grid md:grid-cols-2 gap-8">
            <div className="bg-yellow-50 rounded-xl p-6 border border-yellow-200">
              <h3 className="text-xl font-bold text-yellow-800 mb-4">患者さんへの備え</h3>
              <div className="space-y-4">
                <div className="bg-white rounded-lg p-4">
                  <h4 className="font-semibold text-gray-900 mb-2">💊 お薬の備蓄</h4>
                  <p className="text-gray-600 text-sm">最低7日分、できれば2週間分の薬を常備</p>
                </div>
                <div className="bg-white rounded-lg p-4">
                  <h4 className="font-semibold text-gray-900 mb-2">📖 お薬手帳の携帯</h4>
                  <p className="text-gray-600 text-sm">常に持ち歩き、コピーも別途保管</p>
                </div>
                <div className="bg-white rounded-lg p-4">
                  <h4 className="font-semibold text-gray-900 mb-2">📝 薬剤情報の記録</h4>
                  <p className="text-gray-600 text-sm">薬品名、用法用量、アレルギー情報を記録</p>
                </div>
                <div className="bg-white rounded-lg p-4">
                  <h4 className="font-semibold text-gray-900 mb-2">🏥 かかりつけ薬局の確認</h4>
                  <p className="text-gray-600 text-sm">連絡先と緊急時の対応方法を確認</p>
                </div>
              </div>
            </div>
            
            <div className="bg-blue-50 rounded-xl p-6 border border-blue-200">
              <h3 className="text-xl font-bold text-blue-800 mb-4">薬局・薬剤師の備え</h3>
              <div className="space-y-4">
                <div className="bg-white rounded-lg p-4">
                  <h4 className="font-semibold text-gray-900 mb-2">🏪 事業継続計画（BCP）</h4>
                  <p className="text-gray-600 text-sm">災害時の業務継続体制の整備</p>
                </div>
                <div className="bg-white rounded-lg p-4">
                  <h4 className="font-semibold text-gray-900 mb-2">📦 医薬品の備蓄</h4>
                  <p className="text-gray-600 text-sm">緊急時医薬品の適切な在庫管理</p>
                </div>
                <div className="bg-white rounded-lg p-4">
                  <h4 className="font-semibold text-gray-900 mb-2">🔗 連携体制の構築</h4>
                  <p className="text-gray-600 text-sm">医師会、行政、他薬局との連携強化</p>
                </div>
                <div className="bg-white rounded-lg p-4">
                  <h4 className="font-semibold text-gray-900 mb-2">📚 災害対応研修</h4>
                  <p className="text-gray-600 text-sm">定期的な災害対応訓練の実施</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Emergency Medicine List Section */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl font-bold text-center text-gray-900 mb-12">緊急時医薬品リスト</h2>
          <div className="bg-white rounded-xl shadow-lg p-8">
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
              <div className="bg-red-50 rounded-lg p-4">
                <h3 className="font-bold text-red-800 mb-3">🚨 救急医薬品</h3>
                <ul className="text-sm text-gray-700 space-y-1">
                  <li>• エピネフリン（アナフィラキシー）</li>
                  <li>• ニトログリセリン（狭心症）</li>
                  <li>• インスリン（糖尿病）</li>
                  <li>• 気管支拡張薬（喘息）</li>
                  <li>• 抗けいれん薬（てんかん）</li>
                </ul>
              </div>
              <div className="bg-blue-50 rounded-lg p-4">
                <h3 className="font-bold text-blue-800 mb-3">💊 常備薬</h3>
                <ul className="text-sm text-gray-700 space-y-1">
                  <li>• 解熱鎮痛薬</li>
                  <li>• 総合感冒薬</li>
                  <li>• 胃腸薬</li>
                  <li>• 下痢止め</li>
                  <li>• 便秘薬</li>
                </ul>
              </div>
              <div className="bg-green-50 rounded-lg p-4">
                <h3 className="font-bold text-green-800 mb-3">🩹 外用薬</h3>
                <ul className="text-sm text-gray-700 space-y-1">
                  <li>• 消毒薬</li>
                  <li>• 外用抗生物質</li>
                  <li>• 湿布薬</li>
                  <li>• 軟膏・クリーム</li>
                  <li>• 絆創膏・包帯</li>
                </ul>
              </div>
              <div className="bg-purple-50 rounded-lg p-4">
                <h3 className="font-bold text-purple-800 mb-3">🧴 感染症対策</h3>
                <ul className="text-sm text-gray-700 space-y-1">
                  <li>• 手指消毒薬</li>
                  <li>• マスク</li>
                  <li>• 抗菌薬</li>
                  <li>• うがい薬</li>
                  <li>• 体温計</li>
                </ul>
              </div>
              <div className="bg-orange-50 rounded-lg p-4">
                <h3 className="font-bold text-orange-800 mb-3">🧠 精神科薬</h3>
                <ul className="text-sm text-gray-700 space-y-1">
                  <li>• 抗不安薬</li>
                  <li>• 睡眠薬</li>
                  <li>• 抗うつ薬</li>
                  <li>• 抗精神病薬</li>
                  <li>• 気分安定薬</li>
                </ul>
              </div>
              <div className="bg-teal-50 rounded-lg p-4">
                <h3 className="font-bold text-teal-800 mb-3">👶 小児用薬</h3>
                <ul className="text-sm text-gray-700 space-y-1">
                  <li>• 小児用解熱薬</li>
                  <li>• 小児用感冒薬</li>
                  <li>• 経口補水液</li>
                  <li>• 小児用軟膏</li>
                  <li>• 体温計（小児用）</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Information Section */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl font-bold text-center text-gray-900 mb-12">緊急時相談窓口</h2>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            <div className="bg-white rounded-xl shadow-lg p-6 border border-gray-200">
              <div className="w-12 h-12 bg-red-100 text-red-600 rounded-lg flex items-center justify-center mb-4">
                <i className="ri-phone-line text-xl"></i>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2">中毒110番</h3>
              <p className="text-gray-600 text-sm mb-3">薬物中毒・誤飲時の緊急相談</p>
              <p className="font-bold text-red-600">072-727-2499</p>
              <p className="text-xs text-gray-500">24時間対応（有料）</p>
            </div>
            
            <div className="bg-white rounded-xl shadow-lg p-6 border border-gray-200">
              <div className="w-12 h-12 bg-blue-100 text-blue-600 rounded-lg flex items-center justify-center mb-4">
                <i className="ri-heart-line text-xl"></i>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2">救急安心センター</h3>
              <p className="text-gray-600 text-sm mb-3">救急車を呼ぶべきか迷った時</p>
              <p className="font-bold text-blue-600">#7119</p>
              <p className="text-xs text-gray-500">24時間対応（地域により異なる）</p>
            </div>
            
            <div className="bg-white rounded-xl shadow-lg p-6 border border-gray-200">
              <div className="w-12 h-12 bg-green-100 text-green-600 rounded-lg flex items-center justify-center mb-4">
                <i className="ri-medicine-bottle-line text-xl"></i>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2">薬剤師会</h3>
              <p className="text-gray-600 text-sm mb-3">薬に関する専門的な相談</p>
              <p className="font-bold text-green-600">各都道府県薬剤師会</p>
              <p className="text-xs text-gray-500">平日対応（地域により異なる）</p>
            </div>
            
            <div className="bg-white rounded-xl shadow-lg p-6 border border-gray-200">
              <div className="w-12 h-12 bg-purple-100 text-purple-600 rounded-lg flex items-center justify-center mb-4">
                <i className="ri-mind-map text-xl"></i>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2">こころの健康相談</h3>
              <p className="text-gray-600 text-sm mb-3">精神的な不調・ストレス相談</p>
              <p className="font-bold text-purple-600">各自治体保健所</p>
              <p className="text-xs text-gray-500">平日対応</p>
            </div>
            
            <div className="bg-white rounded-xl shadow-lg p-6 border border-gray-200">
              <div className="w-12 h-12 bg-orange-100 text-orange-600 rounded-lg flex items-center justify-center mb-4">
                <i className="ri-parent-line text-xl"></i>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2">小児救急電話相談</h3>
              <p className="text-gray-600 text-sm mb-3">子どもの急病時の相談</p>
              <p className="font-bold text-orange-600">#8000</p>
              <p className="text-xs text-gray-500">夜間・休日対応</p>
            </div>
            
            <div className="bg-white rounded-xl shadow-lg p-6 border border-gray-200">
              <div className="w-12 h-12 bg-teal-100 text-teal-600 rounded-lg flex items-center justify-center mb-4">
                <i className="ri-information-line text-xl"></i>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2">災害用伝言ダイヤル</h3>
              <p className="text-gray-600 text-sm mb-3">災害時の安否確認</p>
              <p className="font-bold text-teal-600">171</p>
              <p className="text-xs text-gray-500">災害時開設</p>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-900 text-white py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-4 gap-8">
            <div>
              <div className="flex items-center mb-4">
                <div className="w-8 h-8 mr-2 relative">
                  <div className="absolute inset-0 bg-gradient-to-br from-teal-400 to-emerald-400 rounded-lg transform rotate-12"></div>
                  <div className="absolute inset-0 bg-gradient-to-br from-teal-300 to-emerald-300 rounded-lg flex items-center justify-center">
                    <i className="ri-heart-pulse-fill text-white text-sm"></i>
                  </div>
                </div>
                <div className="text-xl font-bold text-teal-400" style={{ fontFamily: '"Pacifico", serif' }}>
                  みんなの薬局～Pharmacare～
                </div>
              </div>
              <p className="text-gray-400">
                患者さんと薬剤師をつなぐ総合医療情報プラットフォーム
              </p>
            </div>
            <div>
              <h3 className="text-lg font-semibold mb-4">患者さん向け</h3>
              <ul className="space-y-2 text-gray-400">
                <li><Link to="/health-support" className="hover:text-white cursor-pointer">健康サポート</Link></li>
                <li><Link to="/self-care" className="hover:text-white cursor-pointer">セルフケア</Link></li>
                <li><Link to="/otc" className="hover:text-white cursor-pointer">OTC医薬品</Link></li>
                <li><Link to="/kampo" className="hover:text-white cursor-pointer">漢方相談</Link></li>
              </ul>
            </div>
            <div>
              <h3 className="text-lg font-semibold mb-4">薬剤師向け</h3>
              <ul className="space-y-2 text-gray-400">
                <li><Link to="/pharmacist-resources" className="hover:text-white cursor-pointer">専門リソース</Link></li>
                <li><Link to="/sterile-preparation" className="hover:text-white cursor-pointer">無菌調剤</Link></li>
                <li><Link to="/home-care" className="hover:text-white cursor-pointer">在宅医療</Link></li>
                <li><Link to="/dx" className="hover:text-white cursor-pointer">薬局DX</Link></li>
              </ul>
            </div>
            <div>
              <h3 className="text-lg font-semibold mb-4">情報・リンク</h3>
              <ul className="space-y-2 text-gray-400">
                <li><Link to="/information" className="hover:text-white cursor-pointer">公的機関リンク</Link></li>
                <li><Link to="/guidelines" className="hover:text-white cursor-pointer">疾患ガイドライン</Link></li>
                <li><Link to="/career" className="hover:text-white cursor-pointer">転職情報</Link></li>
                <li><Link to="/entertainment" className="hover:text-white cursor-pointer">エンタメ</Link></li>
              </ul>
            </div>
          </div>
          <div className="border-t border-gray-800 mt-8 pt-8 text-center text-gray-400">
            <p>&copy; 2024 みんなの薬局～Pharmacare～. All rights reserved. | <a href="https://readdy.ai/?origin=logo" className="hover:text-white cursor-pointer">Website Builder</a></p>
          </div>
        </div>
      </footer>
    </div>
  );
}